module.exports = __webpack_public_path__ + "img/pattern.734dbc1f.png";